export const maximumDuration = 300;

export const CARD_TEXT_ELEMENT_MARGIN = 14;
export const CARD_LAYER_PADDING_X = 30;
export const CARD_LAYER_PADDING_Y = 24;
export const SUBTITLE_LAYER_PADDING = 15;
